import React, { type ReactNode } from "react";
import { BaseInputV2AdornmentContext } from "src/components/BaseInputV2/BaseInputV2AdornmentContext.tsx";
import { css } from "@emotion/react";
import { selectClasses } from "src/components/SelectV2/SelectV2.constants.ts";

export const StartAdornment = ({
  startAdornment,
  disabled = false,
  isButton,
}: {
  startAdornment: ReactNode;
  disabled?: boolean;
  isButton: boolean;
}) => {
  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
      }}
      css={adornmentStyles({ isButton: isButton })}
      className={selectClasses.startAdornment}
    >
      <BaseInputV2AdornmentContext.Provider
        value={{
          disabled,
          position: "end",
        }}
      >
        {startAdornment}
      </BaseInputV2AdornmentContext.Provider>
    </div>
  );
};

const adornmentStyles = ({ isButton }: { isButton: boolean }) => css`
  display: flex;
  align-items: center;
  ${isButton && {
    marginLeft: "10px",
  }}
`;
